export type Option<T> = { type: 'none' } | { type: 'some'; value: T };

export const none: Option<never> = { type: 'none' };

export const some = <T>(value: T): Option<T> => ({ type: 'some', value });

export const fromUndefined = <T>(value: T | undefined): Option<T> =>
  value === undefined ? none : some(value);
